import { useCallback, useState } from "react";
/**
 * A hook that returns a callback ref and the current element returned by that ref.
 * @returns [current, ref]
 */
export function useCallbackRef() {
    const [current, setCurrent] = useState(null);
    const ref = useCallback((node) => {
        if (node !== null) {
            setCurrent(node);
        }
    }, []);
    return [current, ref];
}
